import React, {Component} from 'react';
import {connect} from 'react-redux';
import {PropTypes} from "prop-types";
import {bindActionCreators} from "redux";

import JournalContent from "../../../components/journal/front/detail/content";
import JournalSide from "../../../components/journal/front/detail/side";
import Loading from "../../../components/etc/loading";

import * as Actions from "../../../store/modules/journals";
import * as func from "../../../utils/functions";
import * as hooks from "../../../utils/hooks";

import {BASE_PATH} from "../../../wpconfig";

class Journal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			action : 'journal'
		}
	}

	componentDidMount() {
		hooks.menuHook(this, this.state.action);
		this.getDetail();
	}

	linkToList = () => {
		this.props.history.push(BASE_PATH + "journals/");
	}

	componentWillUnmount(){
		this.setState = (state, callback) => {
			return;
		}
	}

	getDetail() {
		if(!func.getParams("record_id"))
			return;

		func.getData(this.state.action + "/" + func.getParams("record_id"), null).then((response) => {
			if (!this.state.isInit) {
				this.setState({
					isInit: true,
				})
			}
			this.props.dataActions.setJournal(response);

			if(func.getParams("record_id")) {
				let args = {};
				args.issb = response.record.issn;
				args.journal_title = response.record.journal_title;

				func.getWpAjax("rm_get_journal_fulltext_links", args).then((response) => {
					if (response && response.length > 0) {
						let payload = {};
						payload.fullText = response;
						this.props.dataActions.setJournal(payload);
					}
				});

				func.getData("journal/" + func.getParams("record_id") + '/indicator', null).then((response) => {
					if (response.record) {
						response.meta = response.record;
						delete response.record;
					} else {
						response.meta = response;
						// console.log()
					}
					// else if(response.error_code) {
						// response.code = response
					// }

					this.props.dataActions.setJournal(response);
				});

				// func.getData("journal_similar/" + func.getParams("record_id"), null).then((response) => {
				// 	if (response.records) {
				// 		response.similar = response.records;
				// 		delete response.records;
				// 	}
				// 	this.props.dataActions.setJournal(response);
				// });
			}
		});
	}

	render() {
		return (
			<>
				{!this.state.isInit ? <Loading/> :
					<div className="contents-group">
						<JournalContent/>
						<JournalSide/>
						<div id="LineChartToolTip" className="line-chart-tooltip"/>
					</div>
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		// record : state.journals.record ? state.journals.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Journal)

Journal.propTypes = {
	// record : PropTypes.object,
	// records : PropTypes.array,
	// facet : PropTypes.object,
	// totalRecords : PropTypes.number,
	// totalPage : PropTypes.number,
};
